interface InputErrorMessageProps {
  message: string;
}

const InputErrorMessage: React.FC<InputErrorMessageProps> = ({ message }: InputErrorMessageProps) => {
  return <p className='text-sm text-red-100'>{message}</p>;
};

export default InputErrorMessage;
